var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close",
    clipPath: "url(#clip0_4726_5272)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "bg-hub",
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icn-hub",
    clipPath: "url(#clip1_4726_5272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 25.1597L18.0757 31.0804C17.9243 31.2351 17.7146 31.3192 17.4986 31.3121C17.1711 31.3094 16.8773 31.1113 16.7516 30.8097C16.6251 30.5072 16.6914 30.1596 16.9198 29.9252L22.8441 24.0046L16.9198 18.0839C16.7649 17.9326 16.6808 17.723 16.6879 17.5072C16.6826 17.2905 16.7667 17.0818 16.9198 16.9287C17.0729 16.7757 17.2818 16.6917 17.4986 16.697C17.7146 16.6899 17.9243 16.774 18.0757 16.9287L24 22.8494L29.9243 16.9287C30.1562 16.6935 30.5085 16.6227 30.8138 16.7501C31.1183 16.8774 31.3156 17.1764 31.3121 17.5072C31.3192 17.723 31.2351 17.9326 31.0802 18.0839L25.1559 24.0046L31.0802 29.9252C31.3811 30.2472 31.3732 30.7496 31.0607 31.0609C30.7492 31.3731 30.2465 31.3811 29.9244 31.0804L24 25.1597Z",
    fill: "#DFE0E2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4726_5272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4726_5272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoClose);
export default __webpack_public_path__ + "static/media/video_close.da23569b7dac0c2cd73f6e622b52d9bf.svg";
export { ForwardRef as ReactComponent };